import { ExclusiveCategoryPage } from '@lib/kontent/models/ExclusiveCategoryPage'

export function getShouldFetchOnlyMemberDiscountProducts(elements: ExclusiveCategoryPage): boolean {
  if (elements?.fetch_exclusive_discounts_only?.value[0]?.codename === 'yes') {
    return true
  }

  return false
}
